// tslint:disable no-require-imports no-unsafe-any
/**
 * Provides our font and image assets.
 */

export type ImageListType =
  | 'androidMarker'
  | 'badge'
  | 'camera0'
  | 'camera1'
  | 'content0'
  | 'content1'
  | 'content2'
  | 'content3'
  | 'drone0'
  | 'drone1'
  | 'electronic0'
  | 'claimsBot'
  | 'instrument0'
  | 'instrument1'
  | 'instrument2'
  | 'instrument3'
  | 'jewellery0'
  | 'jewellery1'
  | 'jewellery2'
  | 'jewellery3'
  | 'jewellery4'
  | 'jewellery5'
  | 'sport0'
  | 'sport1'
  | 'phone0'
  | 'phone1'
  | 'vehicle0'
  | 'vehicle1'
  | 'vehicle2'
  | 'vehicle3'
  | 'wearable0'
  | 'wearable1'
  | 'spectacles0'
  | 'spectacles1'
  | 'cardBack'
  | 'cardFront'
  | 'poweredByGoogleLogo'
  | 'locator'
  | 'logo'
  | 'medical'
  | 'iosMarker'
  | 'prelogin'
  | 'brandAmex'
  | 'brandDiners'
  | 'brandMaster'
  | 'brandDiscover'
  | 'brandJcb'
  | 'brandPlaceholder'
  | 'emptyBasket'
  | 'brandVisa'
  | 'quoteBot';

import androidMarker from 'assets/icons/androidMarker.png';
import badge from 'assets/icons/badge.png';
import camera0 from 'assets/images/camera/camera_1.jpg';
import camera1 from 'assets/images/camera/camera_2.jpg';
import cardBack from 'assets/images/payment/card_back.png';
import cardFront from 'assets/images/payment/card_front.png';
import claimsBot from 'assets/images/bots/jade_500.jpg';
import content0 from 'assets/images/content/content_1.jpg';
import content1 from 'assets/images/content/content_2.jpg';
import content2 from 'assets/images/content/content_3.jpg';
import content3 from 'assets/images/content/content_4.jpg';
import drone0 from 'assets/images/drone/drone_1.jpg';
import drone1 from 'assets/images/drone/drone_2.jpg';
import electronic0 from 'assets/images/electronics/electronic_1.jpg';
import instrument0 from 'assets/images/instrument/instrument_1.jpg';
import instrument1 from 'assets/images/instrument/instrument_2.jpg';
import instrument2 from 'assets/images/instrument/instrument_3.jpg';
import instrument3 from 'assets/images/instrument/instrument_4.jpg';
import iosMarker from 'assets/icons/iosMarker.png';
import jewellery0 from 'assets/images/jewellery/jewellery_1.jpg';
import jewellery1 from 'assets/images/jewellery/jewellery_2.jpg';
import jewellery2 from 'assets/images/jewellery/jewellery_3.jpg';
import jewellery3 from 'assets/images/jewellery/jewellery_4.jpg';
import jewellery4 from 'assets/images/jewellery/jewellery_5.jpg';
import jewellery5 from 'assets/images/jewellery/jewellery_6.jpg';
import locator from 'assets/icons/locator.png';
import logo from 'assets/images/logo.png';
import medical from 'assets/images/medical/medical.jpg';
import phone0 from 'assets/images/phone/phone_1.jpg';
import phone1 from 'assets/images/phone/phone_2.jpg';
import poweredByGoogleLogo from 'assets/images/maps/powered_by_google_on_white.png';
import prelogin from 'assets/images/backgrounds/prelogin.jpg';
import quoteBot from 'assets/images/bots/rose_500.jpg';
import spectacles0 from 'assets/images/spectacles/spectacles_1.jpg';
import spectacles1 from 'assets/images/spectacles/spectacles_2.jpg';
import sport0 from 'assets/images/sport/sport_1.jpg';
import sport1 from 'assets/images/sport/sport_2.jpg';
import vehicle0 from 'assets/images/vehicles/vehicle_1.jpg';
import vehicle1 from 'assets/images/vehicles/vehicle_2.jpg';
import vehicle2 from 'assets/images/vehicles/vehicle_3.jpg';
import vehicle3 from 'assets/images/vehicles/vehicle_4.jpg';
import wearable0 from 'assets/images/wearable/wearable_1.jpg';
import wearable1 from 'assets/images/wearable/wearable_2.jpg';
import brandAmex from 'assets/icons/payment/amex.png';
import brandDiners from 'assets/icons/payment/stp_card_diners.png';
import brandDiscover from 'assets/icons/payment/stp_card_discover.png';
import brandJcb from 'assets/icons/payment/stp_card_jcb.png';
import brandMaster from 'assets/icons/payment/stp_card_mastercard.png';
import brandPlaceholder from 'assets/icons/payment/stp_card_unknown.png';
import brandVisa from 'assets/icons/payment/stp_card_visa.png';
import emptyBasket from 'assets/images/basket/empty_basket.png';

export type Images = { [key in ImageListType]: string };
export const images: Images = {
  androidMarker,
  badge,
  camera0,
  camera1,
  cardBack,
  cardFront,
  claimsBot,
  content0,
  content1,
  content2,
  content3,
  drone0,
  drone1,
  electronic0,
  instrument0,
  instrument1,
  instrument2,
  instrument3,
  iosMarker,
  jewellery0,
  jewellery1,
  jewellery2,
  jewellery3,
  jewellery4,
  jewellery5,
  locator,
  logo,
  medical,
  phone0,
  phone1,
  poweredByGoogleLogo,
  prelogin,
  quoteBot,
  spectacles0,
  spectacles1,
  sport0,
  sport1,
  vehicle0,
  vehicle1,
  vehicle2,
  vehicle3,
  wearable0,
  wearable1,
  emptyBasket,

  // Payment icons
  brandAmex,
  brandDiners,
  brandDiscover,
  brandJcb,
  brandMaster,
  brandPlaceholder,
  brandVisa,
};
